import React from 'react';
import i18n from '../../../../../i18n';

export class BiddersPositionNew extends React.Component {
  constructor(props) {
    super(props);
    // ── STATE UNCHANGED ──
    this.state = { loadMore: false };
  }

  // ── RENDER ONLY CHANGED ────────────────────────────────────────────────
  render() {
    let top_bidders = this.props.top_bidders;
    let user        = this.props.user;

    // Split podium (top 3) vs rest
    const podium    = Array.isArray(top_bidders) ? top_bidders.slice(0, 3) : [];
    const rest      = Array.isArray(top_bidders) ? top_bidders.slice(3)    : [];
    const hasAny    = Array.isArray(top_bidders) && top_bidders.length > 0;
    const medals    = ['🥇', '🥈', '🥉'];
    const podiumMod = ['--1', '--2', '--3'];

    const displayId = (item) =>
      user.role !== 'CE' && user.role !== 'GM'
        ? item.enroll_number
        : item.username;

    return (
      <React.Fragment>
        <div className="bp-wrap">

          {/* Header */}
          <div className="bp-header">
            <div className="bp-title">
              <div className="bp-title__icon">
                <i className="fa fa-trophy" />
              </div>
              {i18n.t('top_3_bidders')}
            </div>
            <button
              className={`bp-refresh-btn ${this.props.refresh_loading ? 'bp-refresh-btn--loading' : ''}`}
              onClick={this.props.loadTopBidders}
              type="button"
            >
              <i className="mdi mdi-refresh" />
              {i18n.t('refresh')}
            </button>
          </div>

          {/* Body */}
          <div className="bp-body">

            {/* Podium — top 3 */}
            {hasAny && (
              <div className="bp-podium">
                {podium.map((item, i) => {
                  const isMe = item.user_id === user.id;
                  return (
                    <div
                      key={i}
                      className={`bp-podium-item bp-podium-item${podiumMod[i]} ${isMe ? 'bp-podium-item--me' : ''}`}
                    >
                      <span className="bp-podium-medal">{medals[i]}</span>
                      <span className="bp-podium-rank">#{i + 1}</span>
                      <span className="bp-podium-id">{displayId(item)}</span>
                      <span className="bp-podium-amount">{item.bid_amount}</span>
                      {isMe && <span className="bp-me-badge">{i18n.t('my_rank')}</span>}
                    </div>
                  );
                })}
              </div>
            )}

            {/* Table — rank 4+ */}
            {hasAny && rest.length > 0 && (
              <>
                <div className="bp-table-wrap">
                  <table className="bp-table">
                    <thead>
                      <tr>
                        <th style={{ textAlign: 'start' }}>
                          {user.role !== 'CE' && user.role !== 'GM'
                            ? i18n.t('bidder_id')
                            : i18n.t('username')}
                        </th>
                        <th style={{ textAlign: 'center' }}>{i18n.t('rank')}</th>
                        <th style={{ textAlign: 'end' }}>{i18n.t('amount')}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rest.map((item, i) => {
                        const rank  = i + 4;
                        const isMe  = item.user_id === user.id;
                        const hide  = i > (this.state.loadMore ? rest.length : -1)
                          ? '' : (i >= rest.length ? 'd-none' : '');
                        // show first N rows, hide rest until loadMore
                        const shown = this.state.loadMore || i < rest.length;
                        return shown ? (
                          <tr key={i} className={isMe ? 'bp-row--me' : ''}>
                            <td style={{ textAlign: 'start' }}>
                              <span style={{ fontWeight: isMe ? 700 : 400 }}>
                                {displayId(item)}
                              </span>
                            </td>
                            <td style={{ textAlign: 'center' }}>
                              <span className={`bp-rank-badge ${isMe ? 'bp-rank-badge--me' : ''}`}>
                                {isMe ? `${i18n.t('my_rank')} : ` : ''}{rank}
                              </span>
                            </td>
                            <td style={{ textAlign: 'end', fontWeight: isMe ? 700 : 400 }}>
                              {item.bid_amount}
                            </td>
                          </tr>
                        ) : null;
                      })}
                    </tbody>
                  </table>
                </div>
              </>
            )}

            {/* Expand / Collapse */}
            {hasAny && top_bidders.length > 3 && (
              <div className="bp-expand-row">
                {!this.state.loadMore ? (
                  <button onClick={() => this.setState({ loadMore: true })} type="button">
                    <i className="fa fa-chevron-down" />
                    {i18n.t('expand')}
                  </button>
                ) : (
                  <button onClick={() => this.setState({ loadMore: false })} type="button">
                    <i className="fa fa-chevron-up" />
                    {i18n.t('collapse')}
                  </button>
                )}
              </div>
            )}

            {/* Empty state */}
            {!hasAny && (
              <div className="bp-empty">
                <i className="fa fa-users" />
                {i18n.t('no_bidders_found')}
              </div>
            )}
          </div>
        </div>
      </React.Fragment>
    );
  }
}